import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=450abaa4&"
import script from "./Packages.vue?vue&type=script&lang=ts&"
export * from "./Packages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports